export default __webpack_public_path__ + "static/media/engine2.8add6ed8.jpg";